import { SVGProps } from 'react';

export const ListIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    {...props}>
    <path
      d='M5.5 4.5H13.5M5.5 8H13.5M5.5 11.5H13.5M2.5 4.5H2.505V4.505H2.5V4.5ZM2.75 4.5C2.75 4.63807 2.63807 4.75 2.5 4.75C2.36193 4.75 2.25 4.63807 2.25 4.5C2.25 4.36193 2.36193 4.25 2.5 4.25C2.63807 4.25 2.75 4.36193 2.75 4.5ZM2.5 8H2.505V8.005H2.5V8ZM2.75 8C2.75 8.13807 2.63807 8.25 2.5 8.25C2.36193 8.25 2.25 8.13807 2.25 8C2.25 7.86193 2.36193 7.75 2.5 7.75C2.63807 7.75 2.75 7.86193 2.75 8ZM2.5 11.5H2.505V11.505H2.5V11.5ZM2.75 11.5C2.75 11.6381 2.63807 11.75 2.5 11.75C2.36193 11.75 2.25 11.6381 2.25 11.5C2.25 11.3619 2.36193 11.25 2.5 11.25C2.63807 11.25 2.75 11.3619 2.75 11.5Z'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
